/* eslint-disable */
export const sendGenLidOrder = options => new Promise((resolve, reject) => {
	const dataToSend = {
		...options,
		agreedWithPolicy: options.agreedWithPolicy,
		deviceUUID: options.deviceUUID,
	};
	$.ajax({
		url: '/order/leaveGeneralRequest',
		data: dataToSend,
		dataType: 'json',
		type: 'POST',
	}).done(response => {
		if (response.success === true) {
			resolve(response);
		} else {
			console.error('Something wrong', response.message);
			reject(new Error(response.message));
		}
	}).fail(e => {
		console.error('Something wrong! AJAX ERROR!', e);
		reject(e);
	});
});
